import { useTranslation } from '@repo/translations/use-translation';
import { lazy, Suspense } from 'react';

const Benefit1 = lazy(() => import('./benefit1.svg'));
const Benefit2 = lazy(() => import('./benefit2.svg'));
const Benefit3 = lazy(() => import('./benefit3.svg'));
import styles from './ProgramBenefitsSummary.module.css';

export const ProgramBenefitsSummary = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container} data-testid="program-benefits-summary">
      <h2 className={styles.title}>
        {t('loyalty-program.public-landing-page.benefits-summary.title')}
      </h2>
      <ul className={styles.benefits}>
        <li className={styles.benefit}>
          <Suspense fallback={null}>
            <Benefit1 className={styles.icon} aria-hidden />
          </Suspense>
          <p className={styles.description}>
            {t('loyalty-program.public-landing-page.benefits-summary.benefit1')}
          </p>
        </li>
        <li className={styles.benefit}>
          <Suspense fallback={null}>
            <Benefit2 className={styles.icon} aria-hidden />
          </Suspense>
          <p className={styles.description}>
            {t('loyalty-program.public-landing-page.benefits-summary.benefit2')}
          </p>
        </li>
        <li className={styles.benefit}>
          <Suspense fallback={null}>
            <Benefit3 className={styles.icon} aria-hidden />
          </Suspense>
          <p className={styles.description}>
            {t('loyalty-program.public-landing-page.benefits-summary.benefit3')}
          </p>
        </li>
      </ul>
    </div>
  );
};
